import { Component, Input } from '@angular/core';
import { NoteModalComponent } from 'gung-common';

@Component({
  selector: 'otto-olsen-checkout-note-modal',
  standalone: false,
  templateUrl: './otto-olsen-checkout-note-modal.component.html',
  styleUrl: './otto-olsen-checkout-note-modal.component.scss'
})
export class OttoOlsenCheckoutNoteModalComponent extends NoteModalComponent {
  @Input()
  articleNumber: number

  ngOnInit() {
    this.componentId = OttoOlsenCheckoutNoteModalComponent.name;
  }
}
